import Tag from './Tag.styled';

export default Tag;
